import { createReducer, on } from '@ngrx/store';
import { BreakPoint, CardViewType } from '@src/suite/common/enums/enums';

import { BreakPointsActions } from './breakpoints.actions';

export interface BreakPointsState {
    breakPoint?: BreakPoint;
    listBreakPoint: CardViewType;
}

export const initialState: BreakPointsState = {
    listBreakPoint: CardViewType.LARGE,
};

export const breakPointsReducer = createReducer(
    initialState,
    on(BreakPointsActions.setBreakpoint, (state, { breakPoint }): BreakPointsState => {
        return {
            ...state,
            breakPoint,
        };
    }),
    on(BreakPointsActions.setListBreakpoint, (state, { listBreakPoint }): BreakPointsState => {
        if (listBreakPoint === state.listBreakPoint) {
            return state;
        }
        return {
            ...state,
            listBreakPoint,
        };
    })
);
